import React from 'react'
import { assetsPublicPath } from 'server/helpers/env'

export const LenderIcon = ({ lenderName }: { lenderName: string }) => {

  const lenderNameLowerCase = lenderName.toLowerCase()
  const basePath =
    process.env.NODE_ENV === 'development'
      ? `/mortgages/lenders`
      : `${assetsPublicPath}/mortgages/lenders`
  const path = `${basePath}/${lenderNameLowerCase}.png`
  const imgAltDesc = 'Mortgage lender'

  return <img aria-label={`${imgAltDesc} ${lenderName}`} alt={`${lenderName}`} src={path} />
}

export default LenderIcon
